import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { useRouter } from 'next/router'
import { LoadingCover } from '../../../components/commons/LoadingCover'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../../service/wp-blogs-store'
import { TrainerCustomerReviews } from '@/index/service-category/personal-trainer/TrainerCustomerReviews'
import { Faq } from '@/commons/Faq'
import { ptSingaporeFaqs } from 'utils/faq'
import { openModal } from 'service/modal-service'
import { PersonalTrainerHead } from '@/index/service-category/personal-trainer/PersonalTrainerHead'
import { PersonalTrainerBooking } from '@/index/service-category/personal-trainer/PersonalTrainerBooking'
import { RequestProvider } from 'context/RequestContext'
import { PersonalTrainerWhyUs } from '@/index/service-category/personal-trainer/PersonalTrainerWhyUs'
import { getTestimonials } from 'api/user/profile-api'
import { getPtTestimonials, setPtTestimonials } from 'service/testimonial-store'
import { DarkFaq } from '@/index/service-category/personal-trainer/DarkFaq'
import { FaCheckCircle } from 'react-icons/fa'
import TrustedPartners from '@/index/service-category/personal-trainer/TrustedPartners'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-11'

export async function getStaticProps() {
    const countryName = "Singapore"
    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const testimonials = getPtTestimonials().length > 0 ? getPtTestimonials() : await getTestimonials("Fitness Trainer", 0, 6)
    setPtTestimonials(testimonials)
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts,
        testimonials
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const [ isLoading, setIsLoading ] = useState(false)
    const testimonials = props.testimonials
        
    const [ requestForm, setRequestForm ] = useState(false)

    const requestType = "Fitness Trainer"
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router])

  return (
    <>
      <Head>
        <title>Personal Trainer for Muscle Building and Bodybuilding in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Hire certified bodybuilding trainers in Singapore for hypertrophy workouts, protein-rich diets & strength training. Achieve muscle gains quickly with NASM/AAS certified experts. Start bulking today!"/>
        <meta name="keywords" content="bodybuilding personal trainer, muscle building trainer Singapore, hypertrophy training, strength building, certified bodybuilding expert, protein diet plan, progressive overload Singapore"/>
        <meta name="robots" content="index, follow" />
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/personal-trainer/body-building-trainer" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Personal Trainer for Muscle Building and Bodybuilding in Singapore`}/>
        <meta property="og:description" content="Hire certified bodybuilding trainers in Singapore for hypertrophy workouts, protein-rich diets & strength training. Achieve muscle gains quickly with NASM/AAS certified experts. Start bulking today!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-26T07:30:46+00:00" />
        <meta property="article:modified_time" content={`${modifiedDate}`} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Personal-Trainer-Singapore.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Personal-Trainer-Singapore.jpg" />
        <meta name="twitter:site" content="@stringssg"/>
        <meta name="twitter:url" content="https://www.stringssg.com/sg/personal-trainer/body-building-trainer"/>
        <meta name="twitter:title" content={`Personal Trainer for Muscle Building and Bodybuilding in Singapore`}/>
        <meta name="twitter:description" content="Hire certified bodybuilding trainers in Singapore for hypertrophy workouts, protein-rich diets & strength training. Achieve muscle gains quickly with NASM/AAS certified experts. Start bulking today!"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/body-building-trainer" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/body-building-trainer"},"headline":"Personal Trainer For Bodybuilding | Build Muscles Fast","description":"If you are struggling to gain muscles, the guidance of a personal trainer can help to make your body building journey easier.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Personal-Trainer-Singapore.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-26T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"personal-trainer","item":"https://www.stringssg.com/sg/personal-trainer"},{"@type":"ListItem","position":2,"name":"body-building"}]}]}`
          }}
        />
        </Head>
        <div>
            <RequestProvider>
                <PersonalTrainerHead
                    heroImage={s3Static + "Personal-Trainer-Singapore.jpg"}
                    title="Personal Trainer for Strength & Muscle Building in Singapore"
                    heading="Personal Trainer For Bodybuilding in Singapore"
                    heroCopy="Hypertrophy and strength coaching from $84/session. Progressive programming built around the equipment you actually have access to."
                    setIsQuickBook={setIsQuickBook}
                    openRequestForm={openRequestForm}
                    requestForm={requestForm}
                    setRequestForm={setRequestForm}
                    isQuickBook={isQuickBook}
                    isCustomBook={isCustomBook}
                    requestType={requestType}
                    requestCategorySettings={requestCategorySettings}
                />
                <section className="mx-auto py-6 px-2 bg-slate-900 relative">
                    {/* Mesh gradient */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/15 rounded-full blur-3xl" />
                    <div className="absolute bottom-0 left-0 w-80 h-80 bg-amber-400/10 rounded-full blur-3xl" />
                    {/* <h2 className='text-2xl md:text-4xl text-center text-white font-extrabold tracking-tight py-5'>
                        <strong>Personal Trainer for Strength & Muscle Building in Singapore</strong>
                    </h2> */}
                    <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center py-6 relative">                    
                        <div className="text-white/60 space-y-5 leading-relaxed text-lg">
                            <p>
                                Looking to build muscle, increase strength, or sculpt a lean physique? A{" "}
                                <strong>certified personal trainer for bodybuilding</strong> can guide you through
                                customized hypertrophy training, progressive overload plans, and a protein-focused diet
                                to maximize your muscle gains and minimize fat. Whether you&apos;re training at home, a condo
                                gym, or a fitness facility, you&apos;ll receive personalized support to accelerate results. 
                                With hundreds of clients across Singapore and our in-house certified trainers, 
                                we&apos;re here to help you achieve your muscle-building goals.
                            </p>
                            <p>
                                At StringsSG, strength training is one of the key services we offer through our dedicated team of full-time trainers and experienced 
                                fitness professionals across Singapore. We help you get started based on what works best for you:
                            </p>
                            <ul className="space-y-4">
                                <li className="font-bold text-white/90 flex items-center gap-2">
                                    <FaCheckCircle className="text-orange-400" />
                                    Your location
                                </li>
                                <li className="font-bold text-white/90 flex items-center gap-2">
                                    <FaCheckCircle className="text-orange-400" />
                                    Your fitness goals
                                </li>
                                <li className="font-bold text-white/90 flex items-center gap-2">
                                    <FaCheckCircle className="text-orange-400" />
                                    Your preferred training schedule
                                </li>
                            </ul>
                        </div>
                        {/* Image Section */}
                        <div className="relative h-62.5 lg:h-87.5">
                            {/* Floating badge - Certified */}
                            <div className="absolute top-4 right-4 z-10 bg-white/10 backdrop-blur-md rounded-2xl px-4 py-3 shadow-xl border border-white/20">
                                <div className="flex items-center gap-2">
                                    <div className="w-10 h-10 bg-linear-to-br from-green-400 to-emerald-500 rounded-xl flex items-center justify-center">
                                        <FaCheckCircle className="text-white" />
                                    </div>
                                    <div>
                                        <p className="text-xs text-white/50">Certified</p>
                                        <p className="font-bold text-white/90">Trainers</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="relative w-full h-full rounded-3xl overflow-hidden shadow-2xl">
                                <Image
                                    src={s3Static + "personal-trainer/personal-trainer-png.png"}
                                    fill
                                    style={{ objectFit: 'contain', objectPosition: 'top' }}
                                    alt="Personal Trainer Singapore - StringsSG"
                                    sizes="(max-width: 768px) 100vw, 50vw"
                                />
                            </div>
                        </div>
                    </div>                   
                    {/* <TrustedPartners/> */}
                    {/* Section Header */}
                    <div className="max-w-3xl mx-auto text-center mt-12 mb-8 relative z-10">
                        <h2 className="text-2xl md:text-3xl font-extrabold text-white tracking-tight mb-4">What Our Bodybuilding Training Covers</h2>
                        <p className="text-white/50 leading-relaxed">Our certified trainers design structured hypertrophy programs, nutrition plans, and progressive overload protocols to help you build lean muscle mass efficiently—whether you&apos;re a beginner or experienced lifter.</p>
                    </div>
                    {/* Benefit Cards */}
                    <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-6">
                        {[
                        {
                            icon: "💪",
                            title: "Hypertrophy-Focused Training",
                            desc: "Your trainer structures push/pull/leg splits with progressive overload, time-under-tension techniques, and advanced resistance training protocols to trigger optimal muscle growth and strength gains.",
                        },
                        {
                            icon: "🍗",
                            title: "High-Protein Nutrition Plans",
                            desc: "Receive customized meal plans optimized for your BMR, body type, and goals—whether you're bulking, cutting, or body recomposition. Your trainer guides you on protein intake, meal timing, and supplementation.",
                        },
                        {
                            icon: "📊",
                            title: "Measured Progress & Gains",
                            desc: "Your bodybuilding coach tracks weight lifted, rep ranges, form improvements, and body composition changes. Regular assessments ensure you're growing safely, consistently, and breaking through plateaus.",
                        },
                        ].map((item, i) => (
                        <div
                            key={i}
                            className="bg-white/20 rounded-3xl shadow-md p-6 text-center hover:shadow-xl transition transform hover:-translate-y-1"
                        >
                            <div className="text-5xl mb-4">{item.icon}</div>
                            <h3 className="font-semibold text-lg text-white mb-2">{item.title}</h3>
                            <p className="text-white/60 leading-relaxed text-sm">{item.desc}</p>
                        </div>
                        ))}
                    </div>

                    {/* FAQ / Expectations */}
                    <div className="max-w-5xl mx-auto mt-14 space-y-6">
                        <h2 className="text-2xl font-extrabold text-white">
                            How long does it take to build muscle with a personal trainer?
                        </h2>
                        <p className="text-white/60 leading-relaxed">
                        Building muscle is a long-term process. With a dedicated{" "}
                        <strong>bodybuilding personal trainer</strong>, most individuals start seeing noticeable
                        muscle definition and strength gains within 8–12 weeks, especially when following a
                        consistent training and meal plan. Hypertrophy, or muscle growth, relies on steady overload
                        and sufficient recovery.
                        </p>
                        <p className="text-sm text-white/60 italic">
                        Tip: Muscle building is more than lifting heavy—nutrition, sleep, and progressive programming
                        all play crucial roles.
                        </p>
                    </div>

                    {/* CTA */}
                    <div className="mt-10 text-center">
                        <Link
                        href="/sg/personal-trainer"
                        prefetch={false}
                        className="inline-block px-8 py-4 text-white font-semibold rounded-full bg-linear-to-tr from-orange-600 to-amber-400 hover:opacity-90 transition"
                        >
                            Bodybuilding Trainers
                        </Link>
                    </div>
                </section>
                <PersonalTrainerWhyUs/>
                <PersonalTrainerBooking setIsQuickBook={setIsQuickBook} openRequestForm={openRequestForm} year={year} />
                <TrainerCustomerReviews testimonials={testimonials}/>
                <section className="relative py-8 md:py-12 overflow-hidden bg-slate-900">
                    <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500/8 rounded-full blur-3xl" />
                    <div className='relative z-10 max-w-5xl mx-auto px-4'>
                        <DarkFaq 
                            title="Personal Training FAQs"
                            questionsAnswers={ptSingaporeFaqs}
                            // Same Q&A as the hub: only /sg/personal-trainer emits its FAQPage.
                            jsonLd={false}
                        />
                    </div>
                </section>
                <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts} theme="dark"/>       
            </RequestProvider>
        </div>
        {isLoading &&
          <LoadingCover/>
        }
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
